import { useAsync } from "@mylaunch/components/hooks"
import { Result } from "@praha/byethrow"
import { toast } from "sonner"
import { ImSpinner2 } from "react-icons/im"
import { Button } from "~/components/ui/button"

interface Props<TArgs extends unknown[], TResult> extends Omit<React.ComponentProps<typeof Button>, "onClick"> {
  fn: (...args: TArgs) => Promise<TResult>
  onSuccess?: (...args: TArgs) => void | Promise<void>
  isSuccess?: (result: TResult) => boolean
  errorMessage?: string
}

export function AsyncButton<TArgs extends unknown[], TResult>({
  fn,
  onSuccess,
  isSuccess,
  errorMessage,
  children,
  disabled,
  size,
  variant,
  ...props
}: Props<TArgs, TResult>) {
  const { loading, run } = useAsync(fn)

  const handleClick = async (...args: TArgs) => {
    const result = await run(...args)
    if (Result.isFailure(result) || (isSuccess && !isSuccess(result.value))) {
      toast.error(errorMessage || "Что-то пошло не так")
      return
    }
    onSuccess?.(...args)
  }

  const showWithChildren = loading && !size?.includes("icon")

  return (
    <Button disabled={disabled || loading} size={size} variant={variant} {...props} onClick={handleClick as any}>
      {showWithChildren ? (
        <div className="flex items-center gap-s">
          {children} <ImSpinner2 className="animate-spin size-4" />
        </div>
      ) : loading ? (
        <ImSpinner2 className="animate-spin size-4" />
      ) : (
        children
      )}
    </Button>
  )
}
